import { Avatar } from "@material-tailwind/react";
 
export default function Avatarprofile() {
  return <Avatar src="https://koloinatiana.github.io/mon-portfolio/images/profile-round.png" alt="avatar" size="xl"/>;
}